import { Component, OnInit, Inject, Optional } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppState } from '../../../../../../store/reducers';
import { Store } from '@ngrx/store';
import { AlertService } from '../../../../../../commons/services/alert.service';
import { Tenants } from '../../../../../../commons/models/tenants';
import * as TenantsActions from "../../../../../../store/actions/tenants.actions"

@Component({
  selector: 'app-new-tenants',
  templateUrl: './new-tenants.component.html',
  styleUrls: ['./new-tenants.component.scss']
})
export class NewTenantsComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();
  tenantsForm: UntypedFormGroup;
  private _tenant: Tenants;

  constructor(
    private store$: Store<AppState>,
    private alertService: AlertService,
    private fb: UntypedFormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data) {
      this.tenant = this.data.tenant;
    }

    this._createForm();
    this.ngOnChanges();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private _createForm() {
    let group = {
      name: ["", Validators.required],
      phone: ["", Validators.required],
      address: ["", Validators.required],
      city: ["", Validators.required],
      timeSlotInterval: ["", Validators.required],
      maxOrderableProductsPerInterval: ["", Validators.required],
      fidelityCardTargetPoints: ["", Validators.required],
      minimumOrderIntervalTime: ["", Validators.required],
      stripePublicKey: ["", Validators.required],
      stripePrivateKey: ["", Validators.required]
    };

    this.tenantsForm = this.fb.group(group);
  }

  private ngOnChanges() {
    if (this.tenantsForm) {
      this.tenantsForm.reset();

      this._initFormValues(this.tenant);
    }
  }


  private _initFormValues(tenant?: Tenants) {
    if (tenant) {
      this.tenantsForm.patchValue({
        name: tenant.name,
        phone: tenant.phone,
        address: tenant.address,
        city: tenant.city,
        timeSlotInterval: tenant.timeSlotInterval,
        maxOrderableProductsPerInterval: tenant.maxOrderableProductsPerInterval,
        fidelityCardTargetPoints: tenant.fidelityCardTargetPoints,
        minimumOrderIntervalTime: tenant.minimumOrderIntervalTime,
        stripePublicKey: tenant.stripePublicKey,
        stripePrivateKey: tenant.stripePrivateKey,
      });
    } else {
      this.tenantsForm.markAllAsTouched();
    }
  }

  private _prepareSaveTenant(): Tenants {
    return Tenants.fromFormGroup(this.tenantsForm, this.tenant);
  }

  save() {
    let unsavedEntity = this._prepareSaveTenant();
    this.store$.dispatch(TenantsActions.saveTenant({ tenant: unsavedEntity }));
  }

  close() {
    if (this.tenantsForm.dirty) {
      // Se ci sono modifiche, mostra il dialog di conferma
      this.store$.dispatch(TenantsActions.requestCloseTenantsDialog());
    } else {
      // Se il form è pristine (nessuna modifica), chiudi
      this.store$.dispatch(TenantsActions.closeTenantsDialog());
    }
  }

  deleteTenant() {
    if (this.tenant) {
      this.store$.dispatch(TenantsActions.deleteTenant({ tenant: this.tenant.toDTO() }));
    }
  }

  revert() {
    this.ngOnChanges();
  }

  get tenant(): Tenants {
    return this._tenant;
  }

  set tenant(tenant: Tenants) {
    this._tenant = tenant;
    this.ngOnChanges();
  }
}
